import { noneProfile } from "assets";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Calendar, LoaderCircle } from "lucide-react";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";
import InfiniteScroll from "react-infinite-scroll-component";
import { Service } from "utils/services";
import { setIndexTimeSheet } from "store/header";
import { useDispatch } from "react-redux";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import ClockTimesheetPopover from "./ClockTimesheetPopover";

const TimesheetTable = ({
  shopEmployeeTimesheets,
  fetchMoreShopEmployeeTimesheetSearch,
  shopEmployeeLoading,
  listRef,
  selectProducts,
  setSelectedProductIds,
  selectedProductIds,
  setOpenDrawer,
  setItemDetail,
  getShopEmployeeTimesheetDetail,
  dob,
  handleClickUrl,
  openPopoverInTime,
  setOpenPopoverInTime,
  attendanceSetting,
  timeInValues,
  handleChangeTimeIn,
  submitUpdateClockTime,
  loadingsubmitUpdateClockTime,
  openPopoverOutTime,
  setOpenPopoverOutTime,
  timeOutValues,
  handleChangeTimeOut,
  shopEmployeeLoadingState,
  openPopoverbreakOutTime,
  setOpenPopoverbreakOutTime,
  breakOutValues,
  handleChangeBreakOut,
  openPopoverbreakInTime,
  setOpenPopoverbreakInTime,
  breakInValues,
  handleChangeBreakIn,
}: any) => {
  const dispatch = useDispatch();
  return (
    <InfiniteScroll
      dataLength={shopEmployeeTimesheets?.data?.length || 0}
      next={() =>
        fetchMoreShopEmployeeTimesheetSearch({
          next: shopEmployeeLoading.nextPageUrl,
        })
      }
      scrollThreshold="90%"
      hasMore={!!shopEmployeeLoading.nextPageUrl}
      scrollableTarget="scrollableDiv"
      loader={
        <div className="absolute bottom-2 left-0 w-full flex justify-center mt-5">
          <LoaderCircle size={30} className="animate-spin text-yellow-400" />
        </div>
      }
    >
      <>
        {shopEmployeeLoadingState ? (
          <SkeletonMusicLibrariesTable />
        ) : (
          <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden">
            <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
              <tr className="border-none text-[15px]">
                <th className=" py-5 px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                <th className="px-4 text-start text-nowrap">Staff Info. </th>
                <th className="px-4 text-start text-nowrap">Department</th>
                <th className="px-4 text-start text-nowrap">Time In</th>
                <th className="px-4 text-start text-nowrap">Break Out</th>
                <th className="px-4 text-start text-nowrap">Break (In)</th>
                <th className="px-4 text-start text-nowrap">Time Out</th>
                <th className="px-4 text-start text-nowrap">Hour</th>
                <th className="px-4 text-start text-nowrap">Leave</th>
                <th className="px-4 text-start text-nowrap">Remark</th>
              </tr>
            </thead>
            <tbody ref={listRef}>
              {shopEmployeeTimesheets?.data?.map((item: any, index: number) => {
                return (
                  <tr
                    onClick={() => {
                      if (selectProducts) {
                        setSelectedProductIds((prev: any) => (prev.includes(item.id) ? prev.filter((id: any) => id !== item.id) : [...prev, item.id]));
                        return;
                      } else {
                        dispatch(setIndexTimeSheet(item.id));
                      }
                    }}
                    key={index}
                    className={`text-center group cursor-pointer ${index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "} hover:bg-gray-300`}
                  >
                    <td className="relative w-[120px] h-[120px]">
                      <div
                        className={` ${
                          selectedProductIds.includes(item.id) ? "bg-white" : ""
                        } w-4 h-4 rounded-full flex items-center z-50 justify-center absolute left-[6px] top-[6px] text-xl  ${!selectProducts ? " hidden" : " block"}`}
                      >
                        {selectedProductIds.includes(item.id) ? (
                          <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                        ) : (
                          <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                        )}
                      </div>
                      <HoverCardDetail
                        title="Monthly Attendance Detail Report"
                        description={
                          <>
                            <p className="mb-2 font-medium text-sm dark:text-white">Generate and print detailed timesheets for employees to track hours worked.</p>
                            <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                              <li>Includes clock-in/out times, breaks, and total hours.</li>
                              <li>Useful for payroll, attendance verification, and compliance.</li>
                              <li>Customize date ranges and filters before printing.</li>
                              <li>Export options may be available (PDF, Excel, etc.).</li>
                            </ul>
                          </>
                        }
                      >
                        <div
                          onClick={() => {
                            setOpenDrawer(1);
                            setItemDetail({ ...item, dob });
                            handleClickUrl(item?.employee_id, "employee_id", dob);
                            getShopEmployeeTimesheetDetail(item.employee_id);
                          }}
                          className={`${
                            selectProducts ? " hidden" : " block"
                          } group-hover:scale-110 transition-all duration-300 group-hover:opacity-100 opacity-0 w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full absolute z-50 right-[6px] top-2`}
                        >
                          <Calendar className="" />
                        </div>
                      </HoverCardDetail>

                      <ImageUrl src={!item.picture ? noneProfile : item.picture} className="w-[120px] h-[120px] z-1 mx-auto relative" alt="" />
                    </td>

                    <td className="py-2 px-4 text-md text-left align-top">
                      <p className="text-[15px] font-bold my-2">{item.card_no}</p>
                      <p className="text-[15px]  my-2">{item.local_name}</p>
                      <p className="text-md">{item.english_name}</p>
                    </td>

                    <td className="py-2 px-4 text-md  text-left align-top  ">
                      <p className="text-md line-clamp-1 my-2"> {item?.department}</p>
                      <p className="text-md "> {item?.position}</p>
                      <div className="flex items-center gap-1 text-muted-foreground">
                        <p className="text-md text-nowrap"> {Service.formatTime(item?.starting_time)}</p>
                        {item?.starting_time && item?.ending_time && "-"}
                        <p className="text-md text-nowrap "> {Service.formatTime(item?.ending_time)}</p>
                      </div>
                    </td>

                    <td className="py-2 px-4 text-left align-top">
                      <ClockTimesheetPopover
                        item={item}
                        index={index}
                        label="Time In"
                        fieldKey="in_time"
                        openPopoverIndex={openPopoverInTime}
                        setOpenPopoverIndex={setOpenPopoverInTime}
                        timeValue={timeInValues[index]}
                        onChangeTime={handleChangeTimeIn}
                        onSubmitTime={submitUpdateClockTime}
                        loading={loadingsubmitUpdateClockTime}
                        attendanceSetting={attendanceSetting}
                      />
                      <p className="text-sm text-muted-foreground text-nowrap  ">
                        {!item?.late_in ? (item?.early_in !== 0 ? item?.early_in + " Minutes Early" : "") : item?.late_in !== 0 ? item?.late_in + " Minutes Late" : ""}
                      </p>
                      <p className="text-sm text-muted-foreground text-nowrap  ">{item.in_remark}</p>
                    </td>
                    {/* in time */}
                    <td className="py-2 px-4 text-[15px] text-nowrap text-left align-top ">
                      <ClockTimesheetPopover
                        item={item}
                        index={index}
                        label="Break Out"
                        fieldKey="break_out_time"
                        openPopoverIndex={openPopoverbreakOutTime}
                        setOpenPopoverIndex={setOpenPopoverbreakOutTime}
                        timeValue={breakOutValues[index]}
                        onChangeTime={handleChangeBreakOut}
                        onSubmitTime={submitUpdateClockTime}
                        loading={loadingsubmitUpdateClockTime}
                        attendanceSetting={attendanceSetting}
                      />
                      <p className="text-sm text-muted-foreground text-nowrap my-2  ">
                        {!item?.late_break_out
                          ? item?.early_break_out !== 0
                            ? item?.early_break_out + " Minutes Early"
                            : ""
                          : item?.late_break_out !== 0
                          ? item?.late_break_out + "   Minutes Late"
                          : ""}{" "}
                      </p>
                      <p className="text-sm text-muted-foreground text-nowrap  ">{item.break_out_remark}</p>
                    </td>
                    {/* break out */}

                    <td className="py-2 px-4 text-[15px] text-nowrap text-left align-top ">
                      <ClockTimesheetPopover
                        item={item}
                        index={index}
                        label="Break In"
                        fieldKey="break_in_time"
                        openPopoverIndex={openPopoverbreakInTime}
                        setOpenPopoverIndex={setOpenPopoverbreakInTime}
                        timeValue={breakInValues[index]}
                        onChangeTime={handleChangeBreakIn}
                        onSubmitTime={submitUpdateClockTime}
                        loading={loadingsubmitUpdateClockTime}
                        attendanceSetting={attendanceSetting}
                      />
                      {/* late_break_in early_break_in */}
                      <p className="text-sm text-muted-foreground text-nowrap my-2 ">
                        {" "}
                        {!item?.late_break_in
                          ? item?.early_break_in !== 0
                            ? item?.early_break_in + " Minutes Early"
                            : ""
                          : item?.late_break_in !== 0
                          ? item?.late_break_in + "Minutes Late"
                          : ""}
                      </p>
                      <p className="text-sm text-muted-foreground text-nowrap  ">{item.break_in_remark}</p>
                    </td>
                    {/* break in */}

                    {/* ====== */}

                    <td className="py-2 px-4  text-[15px]   text-left align-top text-nowrap ">
                      <ClockTimesheetPopover
                        item={item}
                        index={index}
                        label="Time Out"
                        fieldKey="out_time"
                        openPopoverIndex={openPopoverOutTime}
                        setOpenPopoverIndex={setOpenPopoverOutTime}
                        timeValue={timeOutValues[index]}
                        onChangeTime={handleChangeTimeOut}
                        onSubmitTime={submitUpdateClockTime}
                        loading={loadingsubmitUpdateClockTime}
                        attendanceSetting={attendanceSetting}
                      />

                      <p className="text-sm text-muted-foreground text-nowrap my-2 ">
                        {" "}
                        {!item?.late_out ? (item?.early_out !== 0 ? item?.early_out + " Minutes Early" : "") : item?.late_out !== 0 ? item?.late_out + " Minutes Late" : ""}
                      </p>
                      <p className="text-sm text-muted-foreground text-nowrap  ">{item.out_remark}</p>
                    </td>
                    <td className="py-[6px] px-4 t text-nowrap text-left align-top ">
                      <p className=" my-2 font-bold">{item?.actual_working_hour > 0 ? item?.actual_working_hour : ""}</p>
                    </td>
                    <td className="py-[6px] px-4 font-bold text-nowrap text-left align-top">
                      {item.al > 0 && (
                        <p className={`text-md line-clamp-1 my-2`}>
                          {item.al > 0 ? "AL :" : ""} {item.al > 0 ? item.al : ""}
                        </p>
                      )}
                      {item.sl > 0 && (
                        <p className={`text-md line-clamp-1 my-2 `}>
                          {item.sl > 0 ? "SL :" : ""} {item.sl > 0 ? item.sl : ""}
                        </p>
                      )}
                      {item.ab > 0 && (
                        <p className={`text-md line-clamp-1 my-2 text-red-500 `}>
                          {item.ab > 0 ? "AB :" : ""} {item.ab > 0 ? item.ab : ""}
                        </p>
                      )}
                    </td>

                    <td className="py-2 px-4  text-left align-top">
                      <p className="text-sm text-muted-foreground text-nowrap my-2 ">{item.remark}</p>
                    </td>
                  </tr>
                );
              })}
              {!shopEmployeeTimesheets?.next_page_url ? (
                <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                  <b>Nothing more to load!</b>
                </p>
              ) : (
                ""
              )}
            </tbody>
          </table>
        )}
      </>
    </InfiniteScroll>
  );
};

export default TimesheetTable;
